import { createTransform, PersistConfig, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import RootReducers, { RootState } from './reducers'

type AuthState = RootState['auth']

/**
 * `auth.strongMfaSetupRequired` is a fact the SERVER stated about this session (on the 2FA-verify
 * body or a 428) and must never outlive it: persisted, a gate raised before the user enrolled comes
 * back as true on the next reload with nothing left to clear it — the profile fetch that used to
 * heal it now (correctly) waits for the flag. So it is dropped both on the way out and on the way
 * in. A reload therefore starts from "fully authenticated", the profile fetch validates the session,
 * and a 428 re-raises the gate if setup really is still owed.
 */
const dropSessionRequirements = (auth: AuthState): AuthState => ({ ...auth, strongMfaSetupRequired: false })
const authTransform = createTransform<AuthState, AuthState, RootState>(
  dropSessionRequirements,
  dropSessionRequirements,
  { whitelist: ['auth'] }
)

// Typed explicitly: an untyped config with a transform makes persistReducer infer the state as
// `any`, which degrades RootState for every consumer of the store.
const config: PersistConfig<RootState> = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user'],
  blacklist: ['app', 'player', 'club', 'event', 'user.subscriptions'],
  transforms: [authTransform],
}

const PersistReducer = persistReducer(config, RootReducers)
export default PersistReducer
